import { Chance } from "chance"
import { CompetitorEnum, EtlImport } from "etl/types";

const chance = new Chance();

export const importFactoryMock = (howMany: number): EtlImport[] =>
	Array.from({ length: howMany }).map(() => ({
		"@id": `/api/imports/${chance.guid()}`,
		"@type": "EtlImport",
		uuid: chance.guid(),
		label: chance.sentence(),
		source_name: chance.pickone([CompetitorEnum.Cosium, CompetitorEnum.Dynamic]),
		company_id: chance.integer({ min: 1, max: 100 }),
	}));
